<template>
  <div>
    <portal to="pageTitle">
      <span>Список пользователей</span>
    </portal>

    <v-container style="max-width:1230px;">
      <v-text-field
        outlined
        label="Найти пользователя по логину"
        placeholder="Начните вводить логин..."
        clearable
        prepend-inner-icon="mdi-magnify"
        v-model="searchLogin"
        hide-details
        class="mb-3"
      ></v-text-field>
      <v-text-field
        outlined
        label="Найти пользователя по ID"
        placeholder="Начните вводить ID..."
        clearable
        prepend-inner-icon="mdi-magnify"
        v-model="searchID"
        hide-details
        class="mb-3"
      ></v-text-field>
      <v-progress-linear indeterminate v-if="$apollo.loading"></v-progress-linear>
    </v-container>

    <v-container>
      <UsersList :items="userList ? userList.users : []" />

      <v-pagination class="mt-8" totalVisible="10" v-model="currentPage" :length="Number((userList.itemsCount/10).toFixed(0))-1" v-if="hasPages"></v-pagination>
    </v-container>
  </div>
</template>

<script>
import UsersList from '../../components/widgets/UsersList'

import UserListGQL from '../../graphql/private/User/List.gql'

export default {
  data() {
    return {
      currentPage: +this.$route.query.page || 1,
      refetchCount: 0,
      searchID: '',
      searchLogin: '',
    }
  },

  components: {
    UsersList
  },

  apollo: {
    userList: {
      query: UserListGQL,
      variables() {
        const res = {
          paginate: {
            page: this.currentPage - 1,
            limit: 10
          },
          filter: {
            locale: 'ru',
          },
        }

        if (this.searchID !== '') {
          res.filter.userID = this.searchID
        }

        if (this.searchLogin !== '') {
          res.filter.login = this.searchLogin
        }

        return res
      }
    }
  },

  computed: {
    hasPages() {
      return this.userList && this.userList.itemsCount / 10 > 1
    }
  },

  watch: {
    currentPage(newVal) {
      this.$router.push({
        query: {
          page: newVal
        }
      })
    },

    $route(to) {
      if (to.query.page) {
        this.currentPage = +to.query.page
      }
    }
  }
}
</script>
